"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrivingLicenseCollapseLabelWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var CollapseHtmlWithInfoIconWidget_1 = require("../../components/CollapseHtmlWithInfoIconWidget");
var DrivingLicenseCollapseLabelWidget = /** @class */ (function (_super) {
    __extends(DrivingLicenseCollapseLabelWidget, _super);
    function DrivingLicenseCollapseLabelWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.infoCallback = function (infoState) {
            _this.setState({ showInfo: infoState });
        };
        _this.state = {
            showInfo: false
        };
        return _this;
    }
    DrivingLicenseCollapseLabelWidget.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)("div", { className: "driving-license-collapse-label-widget ".concat(this.state.showInfo ? "background-color-grey inner-content negative-margin" : ""), children: (0, jsx_runtime_1.jsx)(CollapseHtmlWithInfoIconWidget_1.CollapseHtmlWithInfoIconWidget, { title: "Driving license number explained", header: this.getHeader(), content: this.getContent(), parentCallback: this.infoCallback }) }));
    };
    DrivingLicenseCollapseLabelWidget.prototype.getHeader = function () {
        // This is ID reference to Driving licence number input
        return (0, jsx_runtime_1.jsx)("label", { className: "mb-0", htmlFor: "drivingLicenceNumber", children: "Driving licence number" });
    };
    DrivingLicenseCollapseLabelWidget.prototype.getContent = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "card shadow-none mt-3", children: [(0, jsx_runtime_1.jsx)("div", { className: "card-body", children: (0, jsx_runtime_1.jsx)("p", { className: "card-text", children: " This is your full driving licence number which can be found in section 5 of your photocard driving licence" }) }), (0, jsx_runtime_1.jsx)("img", { className: "card-img-bottom img-fluid license-image", src: "/img/licenceImageFrontSpecialNumberAccent.jpg", alt: "License image icon" })] }));
    };
    return DrivingLicenseCollapseLabelWidget;
}(React.Component));
exports.DrivingLicenseCollapseLabelWidget = DrivingLicenseCollapseLabelWidget;
//# sourceMappingURL=DrivingLicenseCollapseLabelWidget.js.map